<div class="login-background" style="background-color: #e9f5ff;">
  <div class="container">
    <div class="login-title">
      <p class="text-title">{{'auth.login.hero' | translate}}</p>
    </div>
    <div class="login-box card">
      <div class="card-body">
        <form class="form-horizontal form-material" id="loginform">
          <img src="assets/images/trobbit-logo.png" alt="trobbit" class="mx-auto d-block trobbit-logo">
          <h4 class="box-title text-center py-4">{{'auth.passwordRecovery.title' | translate}}</h4>
          <div class="form-group m-b-0">
            <div class="col-sm-12 text-center">
              <div><p>{{message}}</p></div>
            </div>
          </div>
          <div class="form-group m-b-0" *ngIf="message===''">
            <div class="col-sm-12 text-center">
              <div>
                <p>{{'auth.passwordRecovery.helpText' | translate}}</p>
              </div>
            </div>
          </div>
          <div class="form-group text-center" *ngIf="message===''">
            <div class="col-xs-12">
              <div class="text-left mx-5">
                <small>{{'auth.email' | translate}}</small>
              </div>
              <input [(ngModel)]="email" name="email" class="form-control input-form" type="email" required="">
            </div>
          </div>
          <ngb-alert type="danger" [dismissible]="false" *ngIf="errorMessage && message===''">
            <strong>{{'common.error' | translate}}: </strong> {{errorMessage}}.
          </ngb-alert>
          <div class="form-group pt-3" *ngIf="message===''">
            <div class="w-100 d-flex justify-content-center">
              <button class="btn btn-info waves-effect waves-light btn-grad" (click)="onSubmit()">
                {{'auth.passwordRecovery.submit' | translate}}
              </button>
            </div>
          </div>
          <div class="form-group m-b-0">
            <div class="w-100 d-flex justify-content-center">
              <div>
                <small class="text-primary" [routerLink]="['/login']">
                  <u>{{'auth.loginLink' | translate}}</u>
                </small>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
